<table class="table table-centered">
  <thead >
    <tr>
      <th>{{'Common.Date'| translate}}</th>
      <th>{{isPrinting? ('Common.ClientAccount'| translate) : ('Common.OracleId'| translate)}}</th>
      <th>{{'Common.BillAmount'| translate}} </th>
      <th>{{'Common.BillNote'| translate}}</th>
      <th>{{'Common.Customer'| translate}}</th>
      <th>{{'Common.ItemsCount'| translate}}</th>
      <th>{{'Common.Status'| translate}}</th>
      @if(!isPrinting){
        <th>{{'Common.storeNumber'| translate}}</th>
        <th>{{'Common.Actions'| translate}}</th>
      }
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let data of dataSource">
      <td>{{data.BILL_DATE}}</td>
      <td>{{data.C_CODE}}</td>
      <td>{{data.BILL_AMT}}</td>
      <td>{{data.BILL_NO}}</td>
      <td>{{data.Customer_Name}}</td>
      <td>{{data.Items_Count}}</td>
      <td>{{data.SentStatus==1 ? ('Common.Sent'|translate) : ('Common.NotSent'|translate) }}</td>
      @if(!isPrinting){
        <td>{{data.W_CODE}}</td>
        <td>
          <div class="d-flex table-actions-column">
            @if (['Wholesale.Create']|permissionCheck) {
              @if(isLoadingMail()==data.Id){
                <div class="px-3">
                  <mat-spinner [diameter]="18"></mat-spinner>
                </div>
              }@else {
                <app-text-button class="action-button" [lucidePrefixIcon]="'send'"  [lucidePrefixColor]="'#475569'" [label]="'Common.SendMail'" (handleClick)="confirmDialog(data)" > </app-text-button>
              }
            }
            <app-text-button class="action-button" [label]="'Common.Details'" [textColorClass]="'color-theme-2'" (handleClick)="showDetails(data)"></app-text-button>
            @if ((['Wholesale.Create']|permissionCheck) && data.SentStatus==2 ) {
              @if(isLoadingBill()==data.Id){
                <div class="px-3">
                  <mat-spinner [diameter]="18"></mat-spinner>
                </div>
              }@else {
                <app-text-button class="action-button" [lucidePrefixIcon]="'send'"  [lucidePrefixColor]="'#475569'" [label]="'Common.SendBill'" (handleClick)="sendOracle(data)" > </app-text-button>
              }
            }
          </div>  
        </td>
      }
    </tr>
  </tbody>
</table>